module.exports = __webpack_public_path__ + "static/media/playstore.92f35f98.png";